import { render, staticRenderFns } from "./PlayerTotalResult.vue?vue&type=template&id=056d4a11&scoped=true&"
import script from "./PlayerTotalResult.vue?vue&type=script&lang=js&"
export * from "./PlayerTotalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d4a11",
  null
  
)

export default component.exports